export const LEADER_LABEL = "activation.widget.topics.leader.label.text";
